import { RelationGraphEmbed } from "components/ObjectTemplateCanvas/RelationGraphEmbed";
import { RelationGraphWidgetConfig, WidgetComponentProps } from "../types";

const DEFAULT_GROUP_LIMIT = 50;
const DEFAULT_ORDER = "-created_at";

/**
 * `relation_graph` widget — embeds the object-template or custom-object relation canvas,
 * scoped by an optional filter instead of loading the full workspace graph.
 */
export const RelationGraphWidget = ({
    config,
}: WidgetComponentProps<RelationGraphWidgetConfig>) => {
    const mode = config?.mode;

    if (mode !== "object_template" && mode !== "custom_object") {
        return (
            <div className="DashboardWidget__error">
                Widget config is missing a valid <code>mode</code> (<code>object_template</code> or{" "}
                <code>custom_object</code>).
            </div>
        );
    }

    const customObjectFilter = config?.custom_object_filter ?? config?.filter;
    const partitionBy = config?.partition_by?.field
        ? {
              ...config.partition_by,
              limit: config.partition_by.limit ?? config.n ?? 1,
              order: config.partition_by.order ?? config.order ?? DEFAULT_ORDER,
          }
        : undefined;

    return (
        <RelationGraphEmbed
            mode={mode}
            filter={config?.filter}
            customObjectFilter={mode === "custom_object" ? customObjectFilter : undefined}
            partitionBy={mode === "custom_object" ? partitionBy : undefined}
            groupLimit={config?.limit ?? DEFAULT_GROUP_LIMIT}
            order={config?.order ?? DEFAULT_ORDER}
        />
    );
};
